import Content from '../Content'
import * as typeStyles from '../../styles/typography.module.css'
import * as styles from './feedbackView.module.css'

const FeedbackView = () =>
  <Content>
    <h1 className={typeStyles.h1Text}>Feedback</h1>
    <div className={styles.para}>
      We want to hear how you feel about CardHero! The good <strong>and the bad</strong>, because we believe in always&nbsp;improving.
    </div>
    <div className={styles.para}>
      You can submit feedback, a bug, or an idea. Thank you in&nbsp;advance!
    </div>
    <iframe src='https://cardhero.hellonext.co' className={styles.feedbackFrame} />
  </Content>

export default FeedbackView
